// extracted by mini-css-extract-plugin
module.exports = {"holder":"holder--8wrnn","progressPercentage":"progressPercentage--4OWXr","progressTracker":"progressTracker--LXEG0","wrapper":"wrapper--kNjiK","box":"box--U9oA4"};